import './mail-event.component.ajscss';

import { RESPONSE_AUTO_NAME } from '@history/core/history-deprecated.service';
import { IComponentController, IComponentOptions, ILogService } from 'angular';
import { i18n } from 'i18next';

import { MomentService, Option } from '@contact/upgrade';

import { IEpticaExctractEvent } from '../models/eptica-extract';
import { EpticaSelector } from '../models/eptica-selector';
import templateUrl from './mail-event.component.html';

class MailEventCtrl implements IComponentController {
  epticaEvent: IEpticaExctractEvent;
  targetSkills: string[];

  constructor(protected readonly $log: ILogService, protected readonly $i18next: i18n, private readonly timeUtil: MomentService) {}

  $onInit(): void {
    this.targetSkills = Option.of(this.epticaEvent.skill)
      .map(wrap => wrap.target)
      .map(skills => skills.map(skill => skill.name))
      .getOrElse([]);
  }

  extractReadableDate(dateToConvert: Date): string {
    return this.timeUtil.readableDate(dateToConvert);
  }

  extractReadableTime(dateToConvert: Date): string {
    return this.timeUtil.readableTime(dateToConvert);
  }

  epticaSupEvent(selector: string): boolean {
    return selector === EpticaSelector.request_event_type_rejected_by_supervisor;
  }

  epticaUserEvent(selector: string): boolean {
    return (
      selector === EpticaSelector.request_event_type_client_message ||
      selector === EpticaSelector.request_event_type_opening ||
      selector === EpticaSelector.request_event_type_monitoring
    );
  }

  epticaAgentEvent(selector: string): boolean {
    return !this.epticaSupEvent(selector) && !this.epticaUserEvent(selector);
  }

  canShow(value: string): boolean {
    return !!(value && value.trim() !== '');
  }

  getFrom(): string {
    if (this.epticaEvent.description.actor.from && this.epticaEvent.description.actor.from.indexOf(RESPONSE_AUTO_NAME) !== -1) {
      return this.$i18next.t('history:viewInteractions.RESPONSE_AUTO');
    }

    return this.epticaEvent.description.actor.from;
  }
}

export class MailEvent implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    epticaEvent: '<',
  };
  controller = ['$log', '$i18next', 'momentService', MailEventCtrl];
}

export default 'mailEvent';
